// =============================================================================
// filter-trigger-label.ts — Libellé du déclencheur d'un filtre MULTI-VALEURS.
// =============================================================================
// Décision GATE_HUMAN du 2026-09-21 (arbitrage 1, « sélection multiple par cases à cocher ») : les
// filtres de la zone campagne passent de la valeur unique à la LISTE. L'état du filtre doit rester
// lisible EN TEXTE sur le déclencheur, jamais porté par la seule couleur (WCAG 1.4.1, ST-NFR-03) :
//
//   aucune sélection  → « Fournisseur · tous »      (paramètre d'URL ABSENT = tous)
//   une sélection     → « Fournisseur · ACME SAS »  (la valeur, pas un compte : plus informatif)
//   n sélections      → « Fournisseur · 3 sélectionnés »
//
// Factorisé parce que quatre écrans du lot F1 composent ce libellé (Analyse, Négociation, Vue
// opérationnelle Profils et Fournisseurs) : une grammaire unique, une seule implémentation.

/**
 * Compose le libellé d'un déclencheur de filtre multi-valeurs.
 *
 * @param label       Nom du filtre (« Fournisseur », « Profil », « Famille »…).
 * @param selectedLabels Libellés AFFICHABLES des valeurs cochées (pas les valeurs techniques : le
 *                    déclencheur d'un filtre fournisseur montre la raison sociale, pas le SIRET).
 * @param allWord     Mot de l'état « aucun filtre » — « tous » par défaut, « toutes » au féminin.
 */
export function filterTriggerLabel(
  label: string,
  selectedLabels: readonly string[],
  allWord = 'tous',
): string {
  if (selectedLabels.length === 0) {
    return `${label} · ${allWord}`;
  }
  if (selectedLabels.length === 1) {
    return `${label} · ${selectedLabels[0] ?? allWord}`;
  }
  return `${label} · ${String(selectedLabels.length)} sélectionnés`;
}
